import { RioNotifications } from '@rio-cloud/rio-notifications-component';
import { OrderChat } from '@rio-cloud/rio-order-chat-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import IframeResizer from '@rio-cloud/iframe-resizer';
import { FormattedMessage } from 'react-intl';

import { config } from '../../config';
import type { HeaderPropertiesFromDispatch, HeaderPropertiesFromState } from './Header.container';

type HeaderProperties = HeaderPropertiesFromDispatch & HeaderPropertiesFromState;

const Header = (props: HeaderProperties) => {
    const { homeRoute, showPositionSharingDialog, userProfile } = props;

    const navItems = [
        {
            key: 'map',
            route: (
                <a href={'https://livemonitor.rio.cloud/#map'}>
                    <FormattedMessage id={'intl-msg:fleetmonitor.subModuleName.monitor'} />
                </a>
            ),
        },
        {
            key: 'pois',
            route: (
                <a href={'/#pois'} className={'active'}>
                    <FormattedMessage id={'intl-msg:fleetmonitor.subModuleName.poi'} />
                </a>
            ),
        },
        {
            key: 'routeHistory',
            route: (
                <a href={'https://asset-history.rio.cloud/'}>
                    <FormattedMessage id={'intl-msg:fleetmonitor.subModuleName.eventHistory'} />
                </a>
            ),
        },
        {
            key: 'positionSharing',
            route: (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a>
                    <div onClick={showPositionSharingDialog}>
                        <FormattedMessage id={'intl-msg:glossary.positionSharing'} />
                    </div>
                </a>
            ),
        },
    ];

    const environment = import.meta.env.PROD ? 'production' : 'local';
    const tenant = userProfile?.tenant || 'unknown';

    const chat = <OrderChat tenant={tenant} />;
    const notifications = <RioNotifications />;
    const userMenu = <DefaultUserMenu environment={environment} />;
    const menuUrl = config.backend.MENU_SERVICE as string;
    const appNavigator = <IframeResizer title='RIO application menu' className={'iFrameResizer'} src={menuUrl} />;

    // eslint-disable-next-line jsx-a11y/anchor-has-content
    const homeLink = <a href={homeRoute} />;

    return (
        <ApplicationHeader
            label={<FormattedMessage id='intl-msg:moduleName' />}
            appNavigator={appNavigator}
            homeRoute={homeLink}
            navItems={navItems}
            actionBarItems={[chat, notifications, userMenu]}
        />
    );
};

export default Header;
